var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTempMangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9224",
    "data-name": "Group 9224",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.447,
    height: 13.889,
    viewBox: "0 0 19.447 13.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3126",
    "data-name": "Rectangle 3126",
    width: 19.447,
    height: 13.889,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9222",
    "data-name": "Group 9222",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M9.777,0H17.3a2.022,2.022,0,0,1,1.054.246,2.071,2.071,0,0,1,1.067,1.526,2.769,2.769,0,0,1,.026.411q0,4.781,0,9.561a2.191,2.191,0,0,1-.439,1.335,1.87,1.87,0,0,1-1.277.765,3.726,3.726,0,0,1-.529.043q-7.472,0-14.944,0a2.275,2.275,0,0,1-1.034-.2,2.045,2.045,0,0,1-1.2-1.719C0,11.81,0,11.647,0,11.484Q0,6.79,0,2.1A1.961,1.961,0,0,1,.3,1,2.016,2.016,0,0,1,1.738.042,3.68,3.68,0,0,1,2.267,0q3.755,0,7.51,0M9.712,12.5h7.466c.054,0,.109,0,.163,0a.7.7,0,0,0,.682-.519,1.341,1.341,0,0,0,.036-.332q0-4.693,0-9.387c0-.054,0-.109,0-.163a.7.7,0,0,0-.525-.678,1.467,1.467,0,0,0-.344-.034q-7.488,0-14.976,0a1.41,1.41,0,0,0-.258.024.674.674,0,0,0-.543.538,2.257,2.257,0,0,0-.023.313q0,4.7,0,9.409c0,.036,0,.072,0,.108a.709.709,0,0,0,.453.668,1.1,1.1,0,0,0,.417.056H9.712",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M63.793,157.489c-.889,0-1.779,0-2.668,0a.753.753,0,0,1-.591-.219.668.668,0,0,1,.4-1.131,2.66,2.66,0,0,1,.356-.021q2.571,0,5.141,0a.926.926,0,0,1,.421.082.653.653,0,0,1,.395.612.666.666,0,0,1-.49.633,1.21,1.21,0,0,1-.32.044c-.882,0-1.764,0-2.647,0",
    transform: "translate(-56.846 -147.079)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M159.788,97.489c-.889,0-1.779,0-2.668,0a.754.754,0,0,1-.575-.206.668.668,0,0,1,.394-1.144,2.789,2.789,0,0,1,.356-.021q2.56,0,5.119,0a1.378,1.378,0,0,1,.331.042.659.659,0,0,1,.5.611.675.675,0,0,1-.588.7,1.907,1.907,0,0,1-.291.021q-1.291,0-2.581,0",
    transform: "translate(-147.289 -90.552)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M206.437,157.481c-.412,0-.824,0-1.236,0a1.511,1.511,0,0,1-.32-.039.668.668,0,0,1,.08-1.31,3,3,0,0,1,.345-.021q1.187,0,2.375,0a1.312,1.312,0,0,1,.331.043.663.663,0,0,1,0,1.282,1.259,1.259,0,0,1-.32.044c-.419,0-.838,0-1.258,0",
    transform: "translate(-192.545 -147.071)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M62.4,97.482c-.412,0-.824,0-1.236,0a1.4,1.4,0,0,1-.3-.037.667.667,0,0,1,.084-1.313,3.465,3.465,0,0,1,.356-.02q1.187,0,2.374,0a.921.921,0,0,1,.41.082.651.651,0,0,1,.39.56.662.662,0,0,1-.492.685,1.2,1.2,0,0,1-.32.043c-.423,0-.846,0-1.268,0",
    transform: "translate(-56.852 -90.545)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempMangeIcon);
export default __webpack_public_path__ + "static/media/temp-mange-icon.7e707055fcf703f93a59424fbed39aed.svg";
export { ForwardRef as ReactComponent };